import { findWhere, pick, extend } from 'underscore';
import {
  bulkModelToViewModelForDayTimeTargets,
  modelToViewModelForDayTimeTargets,
} from './campaign-criterion';
import { viewModelToModelForPredictiveMatching } from './predictive-matching';

const whitelistedSchemaPropertyKeysForModel = [
  'Id', 'Name', 'Budget', 'BiddingScheme', 'AdScheduleUseSearcherTimeZone', 'BidStrategyName', 'AutoTargetingEnabled',
];

export const viewModelToModelForBudget = (campaignViewModel) => {
  let viewModel = { ...pick(campaignViewModel, whitelistedSchemaPropertyKeysForModel) };

  if (campaignViewModel.BiddingScheme) {
    viewModel = extend(viewModel, viewModelToModelForPredictiveMatching(campaignViewModel));
  }

  if (campaignViewModel.Budget) {
    viewModel.BudgetId = campaignViewModel.Budget.Id;
  }
  return viewModel;
};

export const bulkModelToViewModelForBudget = ({
  campaignModel,
  originalCampaignModel,
}) => {
  const data = {
    ...pick(campaignModel, whitelistedSchemaPropertyKeysForModel),
  };

  if (campaignModel.CampaignCriterions) {
    data.dayTimeRanges = bulkModelToViewModelForDayTimeTargets(campaignModel.CampaignCriterions, originalCampaignModel.dayTimeRanges || []);
    data.adSchedulesBulkUpsert = [];
  }
  return data;
};

export const modelToViewModelForBudget = ({
  campaignModel,
  scheduleCriterionModel,
}) => {
  const viewModel = {
    ...pick(campaignModel, whitelistedSchemaPropertyKeysForModel),
  };

  viewModel.dayTimeRanges = scheduleCriterionModel ? modelToViewModelForDayTimeTargets(scheduleCriterionModel) : [];
  viewModel.CampaignSettings = campaignModel.CampaignSettings;

  if (campaignModel.CampaignSettings) {
    const predictiveTargetingSetting = findWhere(campaignModel.CampaignSettings, { '@odata.type': '#Model.PredictiveTargetingSetting' });
    viewModel.BiddingScheme = extend({ AutoTargetingEnabled: (predictiveTargetingSetting && predictiveTargetingSetting.PredictiveTargetingEnabled) || false }, viewModel.BiddingScheme);
    viewModel.AutoTargetingEnabled = (predictiveTargetingSetting && predictiveTargetingSetting.PredictiveTargetingEnabled) || false;
  }

  viewModel.TimeZone = campaignModel.TimeZone;

  return viewModel;
};
